import Button from "@mui/material/Button";
import { CircularProgress } from "@mui/material";
import { removeToken, setToken } from "../../../common/auth";
import useAuthenticateQuery, { AuthenticateData } from "./hooks/use-authenticate-query";
import { useLocation } from "react-router-dom";
import getConfig from "../../../config";

function AuthenticationError({
  message,
  errorMessage
}: {
  message: string;
  errorMessage: string;
  data?: AuthenticateData;
}) {
  return (
    <div className="auth-container">
      <h1>AUTHENTICATION ERROR</h1>
      <div>MESSAGE {message}</div>
      <div>ERROR MESSAGE {JSON.stringify({errorMessage})}</div>
      <a href="/" onClick={() => removeToken()}>
        <Button variant="contained" color="primary">
          Retry Login
        </Button>
      </a>
    </div>
  );
}

function AuthenticationLoading() {
  return (
    <div className="auth-container">
      <CircularProgress />
    </div>
  );
}

function Authenticator({ code }: { code: string }) {
  const { loading, error, data } = useAuthenticateQuery(code);


  if (loading || !data) {
    return <AuthenticationLoading />;
  }

  if (error) {
    return (
      <AuthenticationError
        message="Authentication failed"
        errorMessage={error.message}
        data={data}
      />
    );
  }

  if (data?.authenticate?.success !== true) {
    removeToken();
    return (
      <AuthenticationError
        message={data?.authenticate.message}
        errorMessage={data?.authenticate.errorMessage}
        data={data}
      />
    );
  }
  setToken(data.authenticate.token);

  const closeWindow = localStorage.getItem('closeWindowOnCompletion');
  if (closeWindow) {
    window.close();
  }
  
  const returnTo = localStorage.getItem('returnTo');
  
  if (returnTo) {
    const config = getConfig();
    const returnUrl = config?.returnUrl;
    window.location.href = new URL(returnTo, returnUrl).href;
  } else {
    window.location.reload();
  }

  return null;
}

export default function Authenticate() {
  const { search } = useLocation();
  const params = new URLSearchParams(search);
  const code = params.get("code");

  return code ? (
    <Authenticator code={code} />
  ) : (
    <AuthenticationError
      message="Unable to authenticate"
      errorMessage="Missing CODE param"
      data={undefined}
    />
  );
}
